export default class Hub {
    static init(): void {
        const page = document.querySelector('body#hub') as HTMLBodyElement;
        console.log(page);
        if (!page) {
            return;
        }

        const items = document.querySelectorAll('.hub-item');
        items.forEach((item) => {
            const button = item.querySelector('.btn') as HTMLLinkElement;
            const link = button?.href;
            if (!button || !link) {
                return;
            }

            item.addEventListener('click', () => {
                window.open(link, '_blank');
            });
        });

    }
}
